// Aliquote IRAP per regione (imprese ordinarie non-bancarie/assicurative)
// Valori indicativi 2025: base statale 3,9% + eventuali maggiorazioni regionali
// Fonte: allegati ai bilanci regionali; aggiornabili nel tempo.
export const REGIONI_IRAP = [
  { key: "abruzzo", label: "Abruzzo", aliquota: 4.82 },
  { key: "basilicata", label: "Basilicata", aliquota: 3.90 },
  { key: "calabria", label: "Calabria", aliquota: 4.82 },
  { key: "campania", label: "Campania", aliquota: 4.97 },
  { key: "emilia_romagna", label: "Emilia-Romagna", aliquota: 3.90 },
  { key: "friuli_venezia_giulia", label: "Friuli-Venezia Giulia", aliquota: 3.90 },
  { key: "lazio", label: "Lazio", aliquota: 4.82 },
  { key: "liguria", label: "Liguria", aliquota: 4.65 },
  { key: "lombardia", label: "Lombardia", aliquota: 3.90 },
  { key: "marche", label: "Marche", aliquota: 3.90 },
  { key: "molise", label: "Molise", aliquota: 4.82 },
  { key: "piemonte", label: "Piemonte", aliquota: 3.90 },
  { key: "puglia", label: "Puglia", aliquota: 4.82 },
  { key: "sardegna", label: "Sardegna", aliquota: 3.90 },
  { key: "sicilia", label: "Sicilia", aliquota: 4.82 },
  { key: "toscana", label: "Toscana", aliquota: 3.90 },
  { key: "trentino_alto_adige", label: "Trentino-Alto Adige", aliquota: 2.68 },
  { key: "umbria", label: "Umbria", aliquota: 3.90 },
  { key: "valle_daosta", label: "Valle d'Aosta", aliquota: 3.90 },
  { key: "veneto", label: "Veneto", aliquota: 3.90 },
  { key: "personalizzata", label: "Aliquota personalizzata", aliquota: null },
];

export function findRegioneByAliquota(aliquotaDecimal) {
  const perc = Math.round(aliquotaDecimal * 10000) / 100;
  const found = REGIONI_IRAP.find((r) => r.aliquota !== null && Math.abs(r.aliquota - perc) < 0.001);
  return found ? found.key : "personalizzata";
}
